/**
 * Created by rathompson on 1/9/24
 * File: ActionsRenderer.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { VFC } from 'react'
import type { Row } from 'react-table'
import { Button, Select, SelectItemValue } from '@panwds/react-ui'
import { MoreIcon } from '@panwds/icons'

export interface TableAction {
  disabled?: boolean,
  value: SelectItemValue,
  onActionClick?: Function
}

const ActionsRenderer: VFC<{
  row: Row<any>,
  actions: TableAction[]
}> = ({ row, actions }) => {

  return (
    <Select
      addClassName='cmm-modal-select'
      fitToItemWidth
      items={actions}
      defaultPlacement='bottom'
      button={(
        <Button aria-label='actions' appearance='tertiary-clear' icon={<MoreIcon size='sm' />} />
      )}
      onChange={({ selectedItem }) => {
        const item: TableAction = selectedItem as any
        if (item.onActionClick) {
          item.onActionClick(row)
        }
      }}
    />
  )
}

export default ActionsRenderer
